<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'Welcome',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Welcome!'),
      isDisabled: false,
      invalid: [],
      isResetting: false,
      token: this.$route.query.token,
      password: ''
    };
  },
  mounted() {
    this.$refs.password.focus();
  },
  methods: {
    handleSubmit() {
      this.isResetting = true;

      // Set the user's password
      this.$http
        .post('/auth/confirm', {
          token: this.token,
          password: this.password,
          message: {
            subject: this.$t('Thanks for confirming your {appName} account!', {
              appName: this.$store.state.metadata.appName
            }),
            intro: this.$t(
              "Now that you've confirmed your account, you can manage your website any time using the link below."
            ),
            callToAction: this.$t('Launch {appName}', { appName: this.$store.state.metadata.appName }),
            outro: this.$t('Thanks for using {appName}!', { appName: this.$store.state.metadata.appName })
          }
        })
        .then(res => {
          this.isDisabled = true;
          this.invalid = [];

          // Store session data
          this.$store.commit('setUser', res.data.user);

          // Show a message, then redirect
          this.$notify({
            type: 'success',
            title: this.title,
            message: this.$t('Your password has been updated.'),
            onClose: () => this.$router.push({ name: 'Home' })
          });
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: getErrorMessage(data.code),
              onClose: () => {
                // If the token has expired, redirect the user to the recovery form
                if (data.code === 'INVALID_RECOVERY_TOKEN') {
                  this.$router.push({ name: 'Login' });
                }
              }
            });
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isResetting = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form
      ref="welcomeForm"
      :disabled="isDisabled"
      label-position="top"
      @submit.native.prevent="handleSubmit"
    >
      <h2>{{ $t('Welcome!') }}</h2>
      <p>
        {{ $t('Please choose a password for your new account.') }}
      </p>

      <!-- Password -->
      <el-form-item :class="{ 'is-error': invalid.includes('password') }">
        <el-input
          ref="password"
          v-model="password"
          :placeholder="$t('Password')"
          prefix-icon="el-icon-fa-lock"
          type="password"
          name="password"
          auto-complete="off"
        />
      </el-form-item>

      <!-- Continue button -->
      <el-form-item>
        <el-button
          :loading="isResetting"
          type="primary"
          block
          native-type="submit"
          class="el-button--block"
        >
          {{ $t('Continue') }}
        </el-button>
      </el-form-item>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
